import { useMemo } from "react";
import { useAuthorizedBrands } from "./useAuthorizedBrands";

export const useAuthorizedLocations = (brandSlug?: string, locationSlug?: string) => {
  const brands = useAuthorizedBrands(brandSlug);

  return useMemo(() => {
    return brands
      .map(p => p.locations)
      .reduce((a, b) => a?.concat(b ?? []), [])
      ?.filter(l => !locationSlug || l.urlSlug === locationSlug);
  }, [brands, locationSlug]);
};
